import React from "react";
import StyledButton from "../../../common/models/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// Icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  closeText: {
    fontSize: "1rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  saved: {
    textAlign: "center",
    padding: "0.5rem",
    fontWeight: 500,
    fontSize: "1.5rem",
  },
  text: {
    textAlign: "center",
    fontSize: "0.9rem",
    margin: "1rem",
  },
  iconGrid: {
    display: "flex",
    justifyContent: "center",
  },
  icon: {
    fontSize: "3.5rem",
    color: "#39811D",
  },
  tableContainer: {
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
    border: "2px solid #d0d0d0",
  },
  tableHeader: {
    fontWeight: "normal",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #d0d0d0",
  },
});

const DialogBox = ({
  title,
  subtitle,
  icon,
  handleClose,
  isButtonDisabled,
  tableData,
}) => {
  const classes = useStyles();
  const tableArray = [
    {
      header: "Net Available Quantity",
    },
    {
      header: "UOM",
    },
    {
      header: "Required Quantity",
    },
    {
      header: "Material Code",
    },
    {
      header: "Material Name",
    },


  ];
  return (
    <DialogContent>
      <Grid container justifyContent="flex-end">
        <Grid item xs={12} className={classes.iconGrid}>
          {icon === true ? (
            <CancelIcon className={classes.icon} style={{ color: "red" }} />
          ) : (
            <CheckCircleIcon className={classes.icon} />
          )}
        </Grid>
      </Grid>

      <Typography variant="h5" className={classes.saved}>
        {title}
      </Typography>

      <Typography variant="body2" className={classes.text}>
        {subtitle}
      </Typography>

      {/* Render Table if tableData exists */}
      {tableData && tableData.length > 0 && (
        <div className={classes.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                {/* {Object.keys(tableData[0]).map((key) => (
                  <TableCell key={key} className={classes.tableHeader}>
                    {key.toUpperCase()}
                  </TableCell>
                ))} */}
                {tableArray.map((val, key) => (
                  <TableCell key={key} className={classes.tableHeader}>
                    {val.header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => (
                <TableRow key={index}>
                  {Object.values(row).map((value, idx) => (
                    <TableCell key={idx}>{value}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}

      <Grid item xs={12} style={{ textAlign: "center", paddingBottom: "2rem" }}>
        <StyledButton
          style={{ padding: "0.2rem 2rem" }}
          onClick={handleClose}
          disabled={isButtonDisabled}
        >
          Ok
          <ArrowForwardIosIcon style={{ fontSize: "0.9rem", color: "white" }} />
        </StyledButton>
      </Grid>
    </DialogContent>
  );
};

export default DialogBox;
